import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout/index'
import { proxy4I18n } from '@xpeng/i18n'

Vue.use(Router)

let config = [
  {
    path: '/',
    redirect: '/approval'
  },
  {
    path: '/approval',
    name: 'approval',
    component: Layout,
    redirect: '/approval/approval_list',
    meta: { title: '审批管理', icon: 'approval' },
    children: [
      {
        name: 'approval_list',
        path: 'approval_list',
        component: () => import('@/views/approval/approval_list/index.vue'),
        meta: { title: '审批列表', icon: 'approval_list', keepAlive: true }
      },
      {
        name: 'approval_detail',
        path: 'approval_detail',
        hidden: true,
        component: () => import('@/views/approval/approval_detail/index.vue'),
        meta: { title: '审批详情', icon: 'logs', keepAlive: false }
      },
      {
        name: 'approval_history',
        path: 'approval_history',
        component: () => import('@/views/approval/approval_history/index.vue'),
        meta: { title: '审批历史', icon: 'logs', keepAlive: true }
      },
      {
        name: 'approval_history_detail',
        path: 'approval_history_detail',
        hidden: true,
        component: () => import('@/views/approval/approval_history_detail/index.vue'),
        meta: { title: '审批历史详情', icon: 'logs', keepAlive: false }
      },
      {
        name: 'approval_model',
        path: 'approval_model',
        component: () => import('@/views/approval/approval_model/index.vue'),
        meta: { title: '审批模板', icon: 'approve_model', keepAlive: true }
      },
      {
        name: 'approval_model_detail',
        path: 'approval_model_detail',
        hidden: true,
        component: () => import('@/views/approval/approval_model_detail/index.vue'),
        meta: { title: '审批模板详情', icon: 'logs', keepAlive: false }
      }
    ]
  },
  {
    path: '*',
    component: import('@/views/404/404.vue')
  }
]

export default new Router({
  routes: proxy4I18n(config)
})
